module.exports = __webpack_public_path__ + "static/media/azerbaijan.5700c9ba.png";